import MedicareLeadsComponent from './components/MedicareLeadsComponent'
import ProviderSearchComponent from './components/ProviderSearchComponent'
import ProviderSearchNewComponent from './components/ProviderSearchNewComponent'
let componetToRedirect = undefined;
if(process.env.VUE_APP_MAINVIEW === 'PROV'){
    componetToRedirect = ProviderSearchNewComponent;
}else{
    componetToRedirect = MedicareLeadsComponent;
}
const routes= [
{
path: '/',
name: 'App',
component: componetToRedirect
},
{
path: '/provider',
name: 'AppProvider',
component: ProviderSearchComponent
},
{
path: '/provider/:id',
name: 'AppProvider',
component: ProviderSearchComponent
},
{
path: '/providernew',
name: 'AppProviderNew',
component: ProviderSearchNewComponent
},
{
path: '/providernew/:id',
name: 'AppProviderNew',
component: ProviderSearchNewComponent
}
]
export default routes;
